import React from 'react';

type Props = {
    list: any[];
};

export default function SimpleList({ list }: Props) {
    return (
        <div>
            {Array.isArray(list) && list.length > 0 && (
                <ul>
                    {list.map((item, index) => (
                        <li key={index}>{item}</li>
                    ))}
                </ul>
            )}
        </div>
    );
}
